import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 0,
  class: "relative z-10"
}
const _hoisted_3 = { class: "absolute mt-1" }
const _hoisted_4 = ["value"]

import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { locale } = useI18n()

const calculatedFlag = ref('')
const showLocaleSelector = ref(false)

const toggleLocaleSelector = () => {
  showLocaleSelector.value = !showLocaleSelector.value;
}

const saveLocaleSelected = (event: Event) => {
  const lValue = (event.target as HTMLInputElement).value
  localStorage.setItem("locale", lValue);

  toggleLocaleSelector();
  calculateFlagValue();
}

onMounted(() => {
  locale.value = localStorage.getItem("locale") ?? 'es'
  calculateFlagValue();
})

const calculateFlagValue = () => {
  calculatedFlag.value = `https://unpkg.com/language-icons/icons/${locale.value}.svg`;
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("img", {
      class: "inline-block h-6 w-6 rounded-md select-none",
      onClick: toggleLocaleSelector,
      src: calculatedFlag.value
    }, null, 8, _hoisted_1),
    (showLocaleSelector.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("select", {
              onChange: _cache[0] || (_cache[0] = ($event: any) => (saveLocaleSelected($event))),
              class: "pr-10 block rounded-md",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.$i18n.locale) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$i18n.availableLocales, (locale) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: `locale-${locale}`,
                  value: locale
                }, _toDisplayString(locale), 9, _hoisted_4))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.$i18n.locale]
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})